import apiRequest from './client';

export const listNumberLimits = ({ tirage, group, bank } = {}) => {
  const params = new URLSearchParams();
  if (tirage) params.set('tirage', tirage);
  if (group) params.set('group', group);
  else if (bank) params.set('bank', bank);
  return apiRequest(`/number-limits/?${params.toString()}`);
};

export const createNumberLimit = (data) =>
  apiRequest('/number-limits/', { method: 'POST', body: data });

export const updateNumberLimit = (id, data) =>
  apiRequest(`/number-limits/${id}/`, { method: 'PATCH', body: data });

export const deleteNumberLimit = (id) =>
  apiRequest(`/number-limits/${id}/`, { method: 'DELETE' });
